<div class="flight-item-container" *ngIf="appService.theme$ | async as theme">
    <!-- DATE COLUMN -->
    <div class="column-left">
        <!-- If UTC date format is true -->
        @if (isTimeFormatUTC) {

            @if (isDeadhead && (convertDateToYear(depTimes?.actual?.utc)) == '0001') {
                <div class="day">{{convertDatetoDay(depTimes?.scheduled?.utc)}}</div>
                <div class="monthYear">{{convertDateToMonth(depTimes?.scheduled?.utc)}}</div>
                <div class="monthYear">{{convertDateToYear(depTimes?.scheduled?.utc)}}</div>
            }
            @else {
                <div class="day">{{ isCancelled ? 
                (convertDatetoDay(depTimes?.scheduled?.utc)) : 
                (convertDatetoDay(depTimes?.actual?.utc)) }}
                </div>
                <div class="monthYear">{{ isCancelled ? 
                (convertDateToMonth(depTimes?.scheduled?.utc)) : 
                (convertDateToMonth(depTimes?.actual?.utc)) }}
                </div>
                <div class="monthYear">{{ isCancelled ? 
                (convertDateToYear(depTimes?.scheduled?.utc)) : 
                (convertDateToYear(depTimes?.actual?.utc)) }}
                </div>
            }

            @if ((isCancelled && isDeadhead) || (isCancelled && !isDeadhead)) {
                <div class="tag cx"> {{tag}}</div> 
            } @else if (!isCancelled && isDeadhead) {
                <div class="tag dh">{{tag}}</div>
            } @else {
                <div class="tag flt">{{ tag }}</div>
            }
        }
        <!-- IF LOCAL date format is true -->
        @else {
            @if (isDeadhead && (convertDateToYear(depTimes?.actual?.local)) == '0001') {
                <div class="day">{{convertDatetoDay(depTimes?.scheduled?.local)}}</div>
                <div class="monthYear">{{convertDateToMonth(depTimes?.scheduled?.local)}}</div>
                <div class="monthYear">{{convertDateToYear(depTimes?.scheduled?.local)}}</div>
            }
            @else {
                <div class="day">{{ isCancelled ? 
                (convertDatetoDay(depTimes?.scheduled?.local)) : 
                (convertDatetoDay(depTimes?.actual?.local))}}
                </div>
                <div class="monthYear">{{ isCancelled ? 
                (convertDateToMonth(depTimes?.scheduled?.local)) : 
                (convertDateToMonth(depTimes?.actual?.local)) }}
                </div>
                <div class="monthYear">{{ isCancelled ? 
                (convertDateToYear(depTimes?.scheduled?.local)) : 
                (convertDateToYear(depTimes?.actual?.local)) }}
                </div>
            }
            @if ((isCancelled && isDeadhead) || (isCancelled && !isDeadhead)) {
                <div class="tag cx"> {{tag}}</div> 
            } @else if (!isCancelled && isDeadhead) {
                <div class="tag dh">{{tag}}</div>
            } @else {
                <div class="tag flt">{{ tag }}</div>
            }
        }
    </div>
    <div class="left-divider-1"></div>
    <div class="column-right">
        <!-- Top row Flt number, aicraftType and Reg -->
        <div class="rows top">

            <div class="left-label">AAL{{flightNumber}}</div>

            @if(aircraft && (aircraft.type != null || aircraft.type != undefined)) {
                <div class="center-label">{{aircraft.type.short}}</div>
            }
            @else {
                <div class="center-label">-</div>
            }

            @if(aircraft && (aircraft.id != null || aircraft.id != undefined)) {
                <div class="right-label">{{validateAircraftId(aircraft.id)}}</div>
            }
            @else {
                <div class="right-label"></div>
            }

        </div>
        <!-- Center Row departure station, line, icon, arrival station -->
        <div class="rows center">
            <div class="station-label left"
                [style]="{color: isCancelled ? (theme == 'light' ? 'var(--p-red-600)' : 'var(--p-red-300)') : ''}">
                {{ depStation }}
            </div>
            @if (isDeadhead) {
                @if (isCancelled){
                    <hr [style]="{'background': theme == 'light' ? 'var(--p-red-600)' : 'var(--p-red-300)'}">
                        <img style="width: 17px; height: 17px" [src]="theme == 'light' ? seatCancelLight : seatCancelDark"/>
                    <hr [style]="{'background': theme == 'light' ? 'var(--p-red-600)' : 'var(--p-red-300)'}">
                }
                @else {
                    <hr>
                    <img style="width: 17px; height: 17px" [src]="theme == 'light' ? seatActiveLight : seatActiveDark"/>
                <hr>
                }
            }
            @else if (isCancelled) {
                <hr [style]="{'background': theme == 'light' ? 'var(--p-red-600)' : 'var(--p-red-300)'}">
                    <img style="width: 20px; height: 20px; transform: rotate(90deg);" [src]="theme == 'light' ? airplaneCancelLight : airplaneCancelDark"/>
                <hr [style]="{'background': theme == 'light' ? 'var(--p-red-600)' : 'var(--p-red-300)'}">
            }
            @else {
                <hr>
                    <img style="width: 20px; height: 20px; transform: rotate(90deg);" [src]="theme == 'light' ? airplaneActiveLight : airplaneActiveDark"/>
                <hr>
            }
            <div class="station-label right"
                [style]="{color: isCancelled ? (theme == 'light' ? 'var(--p-red-600)' : 'var(--p-red-300)') : ''}">
                {{ arrStation }}
            </div>
        </div>
        <!-- Bottom Row Actual or sched(if cxl) depart time, flight time, arrival time -->
        @if(isTimeFormatUTC) {
            <div class="rows bottom">
                @if (!isCancelled) {
                    <div class="left-label">
                        {{depTimes?.actual?.utc | formatTime }}Z
                        <!-- <span class="sub-label">({{depTimes?.actual?.local | formatTime}}L)</span> -->
                    </div>
                    <div class="center-label">{{flightTimeActual || '' | formatMinutes  }}</div>
                    <div class="right-label">
                        {{arrTimes?.actual?.utc | formatTime }}Z
                        <!-- <span class="sub-label">({{arrTimes?.actual?.local | formatTime}}L)</span> -->
                    </div>
                }
                @else {
                    <div class="left-label">
                        {{depTimes?.scheduled?.utc | formatTime }}Z
                        <!-- <span class="sub-label">({{depTimes?.scheduled?.local | formatTime }}L)</span> -->
                    </div>
                    <div class="center-label">0:00</div>
                    <div class="right-label">
                        {{arrTimes?.scheduled?.utc | formatTime }}Z
                        <!-- <span class="sub-label">({{arrTimes?.scheduled?.local | formatTime }}L)</span> -->
                    </div>
                }
            </div>
        }
        @else {
            <div class="rows bottom">
                @if (!isCancelled) {
                    <div class="left-label">
                        {{depTimes?.actual?.local | formatTime }}L
                        <!-- <span class="sub-label">({{depTimes?.actual?.utc | formatTime}}Z)</span> -->
                    </div>
                    <div class="center-label">{{flightTimeActual || '' | formatMinutes  }}</div>
                    <div class="right-label">
                        {{arrTimes?.actual?.local | formatTime }}L
                        <!-- <span class="sub-label">({{arrTimes?.actual?.utc | formatTime}}Z)</span> -->
                    </div>
                }
                @else {
                    <div class="left-label">
                        {{depTimes?.scheduled?.local | formatTime }}L
                        <!-- <span class="sub-label">({{depTimes?.scheduled?.utc | formatTime }}Z)</span> -->
                    </div>
                    <div class="center-label">0:00</div>
                    <div class="right-label">
                        {{arrTimes?.scheduled?.local | formatTime }}L
                        <!-- <span class="sub-label">({{arrTimes?.scheduled?.utc | formatTime }}Z)</span> -->
                    </div>
                }
            </div>
        }
    </div>
</div>
